(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["native-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('native-announcement-bar')) {
    customElements.define(
      'native-announcement-bar',
      class NativeAnnouncementBar extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('.native-announcement__item'));
          this.index = 0;
          this.paused = false;
          ['mouseenter', 'focusin', 'touchstart'].forEach((type) =>
            this.addEventListener(type, () => (this.paused = true), { passive: true })
          );
          ['mouseleave', 'focusout', 'touchend'].forEach((type) =>
            this.addEventListener(type, () => (this.paused = false), { passive: true })
          );
          this.querySelectorAll('.native-announcement__arrow').forEach((button) =>
            button.addEventListener('click', () => {
              this.show(this.index + Number(button.dataset.step), Number(button.dataset.step));
              this.start();
            })
          );
          this.start();
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        start() {
          clearInterval(this.timer);
          if (this.items.length < 2) return;
          const seconds = Number(this.dataset.interval) || 4;
          this.timer = setInterval(() => {
            if (!this.paused && !document.hidden) this.show(this.index + 1, 1);
          }, seconds * 1000);
        }

        show(index, step) {
          const leaving = this.items[this.index];
          this.items.forEach((item) => item.classList.remove('is-leaving'));
          this.setAttribute('data-animate', '');
          this.dataset.direction = step < 0 ? 'prev' : 'next';
          leaving.classList.remove('is-active');
          leaving.classList.add('is-leaving');
          clearTimeout(this.leaveTimer);
          this.leaveTimer = setTimeout(() => leaving.classList.remove('is-leaving'), 500);
          this.index = (index + this.items.length) % this.items.length;
          this.items[this.index].classList.add('is-active');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["native-footer"]) return;
  try {
    
  if (!customElements.get('native-footer-menus')) {
    customElements.define(
      'native-footer-menus',
      class NativeFooterMenus extends HTMLElement {
        connectedCallback() {
          this.desktop = window.matchMedia('(min-width: 750px)');
          this.menus = Array.from(this.querySelectorAll('details'));
          this.sync = () => {
            if (this.isDesktop === this.desktop.matches) return;
            this.isDesktop = this.desktop.matches;
            this.menus.forEach((menu) => (menu.open = this.isDesktop));
          };
          this.querySelectorAll('summary').forEach((summary) =>
            summary.addEventListener('click', (event) => {
              if (this.desktop.matches) event.preventDefault();
            })
          );
          this.desktop.addEventListener('change', this.sync);
          window.addEventListener('resize', this.sync);
          this.sync();
        }

        disconnectedCallback() {
          this.desktop.removeEventListener('change', this.sync);
          window.removeEventListener('resize', this.sync);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["native-home-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('native-home-hero-slider')) {
    customElements.define(
      'native-home-hero-slider',
      class NativeHomeHeroSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.native-home-slider__track');
          this.originals = Array.from(this.querySelectorAll('.native-home-slider__slide'));
          this.bullets = Array.from(this.querySelectorAll('.native-home-slider__bullet'));
          this.count = this.originals.length;
          if (this.count < 2) return;

          // Une copie du jeu de diapositives permet de boucler sans voir la diapositive
          // qui change de côté : elle saute hors champ, jamais au travers du centre.
          this.items = this.originals.concat(
            this.originals.map((slide) => {
              const clone = slide.cloneNode(true);
              clone.setAttribute('aria-hidden', 'true');
              clone.inert = true;
              clone.querySelectorAll('h1').forEach((heading) => {
                const div = document.createElement('div');
                div.className = heading.className;
                div.textContent = heading.textContent;
                heading.replaceWith(div);
              });
              this.track.appendChild(clone);
              return clone;
            })
          );
          this.current = 0;
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.layout(false);

          this.bullets.forEach((bullet) =>
            bullet.addEventListener('click', () => this.goTo(Number(bullet.dataset.index)))
          );
          this.track.addEventListener('click', (event) => {
            if (this.swiped) return;
            const rect = this.items[this.current].getBoundingClientRect();
            if (event.clientX < rect.left) this.step(-1);
            if (event.clientX > rect.right) this.step(1);
          });
          this.track.addEventListener('pointerdown', (event) => {
            this.startX = event.clientX;
            this.swiped = false;
          });
          this.track.addEventListener('pointerup', (event) => {
            if (this.startX === undefined) return;
            const delta = event.clientX - this.startX;
            this.startX = undefined;
            if (Math.abs(delta) > 40) {
              this.swiped = true;
              this.step(delta < 0 ? 1 : -1);
            }
          });
          const pauseEvents = ['focusin'];
          const resumeEvents = ['focusout'];
          if (window.matchMedia('(hover: hover)').matches) {
            pauseEvents.push('mouseenter');
            resumeEvents.push('mouseleave');
          }
          pauseEvents.forEach((type) => this.addEventListener(type, () => this.setAttribute('data-paused', '')));
          resumeEvents.forEach((type) => this.addEventListener(type, () => this.removeAttribute('data-paused')));
          this.addEventListener('animationend', (event) => {
            if (event.target.classList.contains('native-home-slider__bullet-fill')) this.step(1);
          });
          if (Number(this.dataset.autoplay) > 0 && !this.reduceMotion) this.setAttribute('data-autoplay-on', '');
        }

        step(direction) {
          this.show(this.current + direction);
        }

        goTo(index) {
          const position = this.current % this.count;
          let delta = index - position;
          if (delta > this.count / 2) delta -= this.count;
          if (delta < -this.count / 2) delta += this.count;
          this.show(this.current + delta);
        }

        show(target) {
          const total = this.items.length;
          this.current = ((target % total) + total) % total;
          this.layout(!this.reduceMotion);
          const index = this.current % this.count;
          this.bullets.forEach((bullet, i) => {
            bullet.classList.remove('is-active');
            bullet.removeAttribute('aria-current');
            if (i === index) {
              void bullet.offsetWidth;
              bullet.classList.add('is-active');
              bullet.setAttribute('aria-current', 'true');
            }
          });
        }

        layout(animate) {
          const total = this.items.length;
          this.items.forEach((item, i) => {
            let offset = (((i - this.current) % total) + total) % total;
            if (offset > total / 2) offset -= total;
            const jump = item.dataset.offset !== undefined && Math.abs(offset - Number(item.dataset.offset)) > 1;
            item.style.transition = animate && !jump ? '' : 'none';
            item.style.setProperty('--native-home-slider-offset', offset);
            item.dataset.offset = offset;
            const active = offset === 0;
            item.classList.toggle('is-active', active);
            if (i < this.count) item.inert = !active;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["native-home-product-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('native-home-product-rail')) {
    customElements.define(
      'native-home-product-rail',
      class NativeHomeProductRail extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.native-home-rail__track');
          this.arrows = Array.from(this.querySelectorAll('.native-home-rail__arrow'));
          this.arrows.forEach((arrow) =>
            arrow.addEventListener('click', () => {
              const item = this.track.querySelector('.native-home-rail__item');
              const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
              const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
              this.track.scrollBy({ left: Number(arrow.dataset.step) * step, behavior: 'smooth' });
            })
          );
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          window.addEventListener('resize', () => this.update());
          this.update();
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth - 1;
          this.arrows[0].disabled = this.track.scrollLeft <= 0;
          this.arrows[1].disabled = this.track.scrollLeft >= max;
          this.toggleAttribute('data-static', max <= 0);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["native-home-scale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('native-home-scale')) {
    customElements.define(
      'native-home-scale',
      class NativeHomeScale extends HTMLElement {
        connectedCallback() {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
          this.dataset.reveal = 'pending';
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.dataset.reveal = 'done';
              this.observer.disconnect();
            },
            { threshold: 0.35 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
